import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function useNavigateBackToCustomFields(): () => void {
  const history = useHistory();
  const { pathname } = useLocation();

  return useCallback(() => {
    const configPath = pathname.replace(/\/custom-fields(\/[^/]*)?$/, '');

    history.push(`${configPath}?tab=customFields`);
  }, [history, pathname]);
}
